import Product from './Product';
import Details from './Details';
import { Tabs, TabsList, TabsContent, TabsTrigger } from '@/components/shadcn/ui/tabs';
import Situation from './Situation';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import negocio from '@/validations/schemas/negocio';
import { zodResolver } from '@hookform/resolvers/zod';
import { ProductWithBusinessProvider, useProductWithBusinessContext } from './ProductWithBusinessContext';
import { Button } from '@/components/shadcn/ui/button';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { useEffect } from 'react';
import { useProductWithBusiness } from '@/hook/useProductWithBusiness';
import { BusinessUpdateInterface } from '@/entities/business';
import { useBusiness } from '@/hook/useBusiness';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import React from 'react';
import { toast } from '@/components/shadcn/ui/use-toast';
import Timeline from '../Timeline';
import { TaskProvider } from '@/context/TaskContext';
function FormDetalhe() {
  const methods = useForm({ resolver: zodResolver(negocio) });
  const {businessEdit, business, businessEdit2, setBusinessEdit2, fetchbusinessById} = useBusinessDetailContext();
  const {selectedProducts} = useProductWithBusinessContext();
  const { updateBusiness } = useBusiness();
  const {  productsBusiness, productsWithBusiness, createOrUpdateProductWithBusiness, createBusinessProduct, updateBusinessProduct, fetchBusinessProductWithId, deleteBusinessProduct } = useProductWithBusiness();
  useEffect(()=>{
    
    fetchbusinessById();
    // console.log(business);
  },[]);


  const {leadId} = useParams<{leadId:string}>();
  const leadId2Set = Number(leadId);
  const {business2} = useBusiness(leadId2Set);
  const {accessToken} = useAuthContext(); 

  const onSubmit = async (data: any) =>{
    
    const updateData:BusinessUpdateInterface = {
      description: data.descricao,
      contactNumber: data.tel,
      observation: data.observacao,
      prevision: data.previsao,
      closedAt: data.dtfechamento,
      reason:data.motivo,
      status: data.situacao,
      startedAt: data.dtinicio,
      updatedAt: new Date(),
      clientId: data.client,
      activityTypesId: data.idtiponegocio,
      businessSourceId: data.idfontenegocio
    };
    // console.log(updateData);
    const result = await updateBusiness(leadId2Set,updateData);

    if(result != undefined){if (result.success) {
      toast({ description: "Dados alterados com sucesso!" });
    } else {
      toast({ description: "Ocorreu um erro! Dados não foram salvos.\n Preencha todos os campos", variant: "destructive" });
    }}
    

  };

  return (
    <div className='bg-indigo-200 h-full border-l border-slate-200'>
      <FormProvider {...methods}>
        <div className='flex flex-col gap-4'>
          <Tabs defaultValue='detail' className='w-full h-auto min-h-max bg-white'>
            <TabsList className='grid w-full grid-cols-2 h-auto min-h-max border-b rounded-0'>
              <TabsTrigger value='timeline'>Timeline</TabsTrigger>
              <TabsTrigger value='detail'>Detalhes</TabsTrigger>
            </TabsList>
            <TabsContent value='timeline' className=' bg-indigo-200 w-full '>
              <TaskProvider>
                <Timeline/>
              </TaskProvider>
            </TabsContent>
            <TabsContent value='detail' className='bg-indigo-200 w-full '>
              <TaskProvider>
                <Details/>
              </TaskProvider>
            </TabsContent>
          </Tabs>
        </div>
      </FormProvider>
    </div>
  );
}

export default FormDetalhe;
